import React, { useEffect,useState} from 'react';
import { makeStyles} from '@material-ui/core/styles';
import Bread from '../component/Breadcrumbs';
import Sidebar from '../component/Sidebar';
import {UserList} from '../Services/User';
import {AuthData,commission} from '../Services/Authdata';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import {AdminProfile} from '../Services/AdminLogin';
import {commissionvalidation} from '../Pages/Auth/UpdateValidation';
import useForm from '../Pages/Auth/useForm';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
import Backdrop from '@material-ui/core/Backdrop';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));


const Commision = (props) =>  {
  const br = [{
    'title':'Flight',
    'icon':"",
    'url':'/flight'
  }];
  const classes = useStyles();
  const [data, setData] = useState();
  const [open,setOpen] = useState(false);
  const [loader, setLoader] = useState("");
  const [action, setAction] = useState(false);
  const initialValues = {
		    trawex_flight:commission().trawex,
        ticket_master:0,
        hotelbeds:commission().hotelbeds,
        tbo:commission().tbo
  }
  const { values, errors, handleChange, handleSubmit } = useForm(initialValues,profile,commissionvalidation);
  const sendData = (message) => {
    props.parentCallback(message);
  }
  function profile() {
    setOpen(true)
    //console.log(values)
    AdminProfile('commission/','POST',AuthData().token,values)
    .then((result)=>{
       localStorage.removeItem("com",JSON.stringify(result.data))
        localStorage.setItem("com",JSON.stringify(result.data))
       setOpen(false)
    });

}


  return (
    <div className={classes.root}>
      <Backdrop className={classes.backdrop} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Sidebar />
      <main className={classes.content}>
      <div className={classes.toolbar} />
      <Bread data={br}/>
       <h1>Set Up Provider Commisions</h1>
       <form 
       onSubmit={handleSubmit} 
       noValidate
       >


            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <FormControl style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                        <TextField 
                        id="trawex_flight"
                        InputProps={{
                          startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }}
                        error={errors.trawex_flight?true:false}
                        helperText={errors.trawex_flight}
                        label="Trawex Flight"
                        variant="outlined"
                        type="number"
                        name='trawex_flight' 
                        required
                        size="small"
                        onChange={handleChange}
                        defaultValue={commission().trawex}
                        />
                    </FormControl>
                </Grid>
                {/* <Grid item xs={12} sm={6}>
                    <FormControl style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                        <TextField 
                        InputProps={{
                          startAdornment: <InputAdornment position="start">%</InputAdornment>,
                        }}
                        error={errors.ticket_master?true:false}
                        helperText={errors.ticket_master}
                        id="email"
                        label="Ticket Master"
                        variant="outlined"
                        type="number"
                        name='ticket_master' 
                        size="small"
                        required
                        onChange={handleChange}
                        defaultValue={commission().ticket}
                        />
                    </FormControl>
                </Grid> */}
                <Grid item xs={12} sm={6}>
                    <FormControl style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                        <TextField 
                        InputProps={{
                          startAdornment: <InputAdornment position="start">%</InputAdornment>,
                        }}
                        id="hotelbeds"
                        error={errors.hotelbeds?true:false}
                        helperText={errors.hotelbeds}
                        label="Hotel Beds"
                        variant="outlined"
                        type="number"
                        name='hotelbeds' 
                        required
                        size="small"
                        onChange={handleChange}
                        defaultValue={commission().hotelbeds}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                        <TextField 
                        InputProps={{
                          startAdornment: <InputAdornment position="start">%</InputAdornment>,
                        }}
                        error={errors.tbo?true:false}
                        helperText={errors.tbo}
                        id="tbo"
                        label="TBO"
                        variant="outlined"
                        type="number"
                        name='tbo' 
                        size="small"
                        required
                        onChange={handleChange}
                        defaultValue={commission().tbo}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <FormControl style={{marginTop:"5px"}}>
                <Button type="submit" disabled={action} variant="contained" color="primary" disableElevation>Save</Button>
            </FormControl>
        </form>
      </main>
    </div>
    
   
  );
}

export default Commision;


// WEBPACK FOOTER //
// ./src/Pages/Commision.js